export const heightTransition = 'height 1s';
export const maxHeightTransition = 'max-height 1s, height 1s';

export const loadingAnimationTime = 3000;
